import type { SignInOutput } from "aws-amplify/auth";

import type { ChallengedUser } from "@/routes/_unauthenticated/sign-in";

export type SignInFlowResult =
  | { action: "signed_in" }
  | { action: "start_password_reset"; username: string }
  | { action: "set_challenged_user"; user: ChallengedUser }
  | { action: "redirect_unconfirmed"; username: string }
  | { action: "show_error"; kind: "generic" | "resend_failed" | "message"; message?: string };

type AuthError = Error & { code?: string; name?: string };

export function interpretSignInResult(result: SignInOutput, username: string): SignInFlowResult {
  if (result.isSignedIn) {
    return { action: "signed_in" };
  }

  switch (result.nextStep.signInStep) {
    case "RESET_PASSWORD":
      return { action: "start_password_reset", username };
    case "CONFIRM_SIGN_UP":
      return { action: "redirect_unconfirmed", username };
    case "CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED":
      return { action: "set_challenged_user", user: { challengeName: "NEW_PASSWORD_REQUIRED", email: username } };
    case "CONFIRM_SIGN_IN_WITH_TOTP_CODE":
      return { action: "set_challenged_user", user: { challengeName: "SOFTWARE_TOKEN_MFA", email: username } };
    default:
      return { action: "show_error", kind: "generic" };
  }
}

export function interpretSignInError(error: AuthError, username: string): SignInFlowResult {
  const errorCode = error.name ?? error.code;

  if (errorCode === "PasswordResetRequiredException") {
    return { action: "start_password_reset", username };
  }

  if (errorCode === "UserNotConfirmedException") {
    return { action: "redirect_unconfirmed", username };
  }

  return { action: "show_error", kind: "message", message: error.message };
}

export function passwordContainsWhitespace(password: string): boolean {
  return /\s/.test(password);
}
